import { Check, Truck } from "lucide-react";


export const WagonProgress = ({ number, progress, active, dispatched }) => (
  <div className={`mining-wagon ${active ? "is-active" : ""} ${dispatched ? "is-dispatched" : ""}`} data-testid={`wagon-${number}-status`}>
    <div className="mining-wagon-head">
      <span className="mining-wagon-icon" aria-hidden="true">{dispatched ? <Check size={16} /> : <Truck size={16} />}</span>
      <div>
        <small>WAGON {number}</small>
        <strong>{dispatched ? "Dispatched" : active ? "Loading" : "Waiting"}</strong>
      </div>
      <b data-testid={`wagon-${number}-percentage`}>{progress}%</b>
    </div>
    <div
      className="mining-progress-track"
      role="progressbar"
      aria-label={`Wagon ${number} capacity`}
      aria-valuemin="0"
      aria-valuemax="100"
      aria-valuenow={progress}
      data-testid={`wagon-${number}-progress`}
    >
      <span style={{ width: `${progress}%` }} />
    </div>
  </div>
);
